import { Inject, Injectable, Optional, Pipe, PipeTransform } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RegisterData, RegisterParams } from '../resolvers/register.resolver';
import { TypedActivatedRoute, getCurrentRegisterLocale } from '../utils/route-utils';

@Injectable({ providedIn: 'root' })
@Pipe({
  name: 'ize',
  pure: false,
  standalone: false,
})
export class IzePipe implements PipeTransform {
  constructor(
    // Optional helps with testing - activated route should always be there in reality
    @Optional()
    @Inject(ActivatedRoute)
    private route?: TypedActivatedRoute<Partial<RegisterParams>, Partial<RegisterData>>,
  ) {}

  transform(value: string) {
    /*
     * NOTE: When updating these rules make sure to update the lint
     * rule in /eslint-plugins/ize
     */
    // CASE SENSITIVE - will need to handle casing if this changes
    return (
      value
        /*
         * Regex explanation:
         * - mid-word (not a word boundary)
         * - 'is' or 'iz'
         * - zero-width lookahead (this part will not be replaced)
         *   - 'e', 'es', 'ed', 'ing', 'ation' or 'ations'
         *   - then end of word
         * This will perform these translations in both directions:
         * - organisation  -> organization
         * - organisations -> organizations
         * - organise      -> organize
         * - organises     -> organizes
         * - organised     -> organized
         * - organising    -> organizing
         */
        .replace(
          /\B(?!size|wise)([a-z])i[sz](?=(e[sd]?|ing|ations?)\b)/g,
          this.useZ() ? '$1iz' : '$1is',
        )
        .replace(/\b([Cc]ent)(re|er)(?=s?\b)/g, this.useCenter() ? '$1er' : '$1re')
    );
  }

  private useZ() {
    return true;
  }

  private useCenter() {
    switch (getCurrentRegisterLocale(this.route?.snapshot)) {
      case 'en-CA':
        return false;
    }

    return true;
  }
}
